// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"8aacef27","339":"e5490115","349":"6be6f989","427":"1b0eea36","435":"13b5e9aa","453":"68693753","457":"f9d096c3","651":"1bc03575","797":"70e3a552","808":"918b327c","888":"2381c926"}[chunkId] + ".chunk.js";
};